/**
 * Override global de console.log para desactivar logs en producción
 * Este archivo intercepta TODOS los console.log sin modificar archivos existentes
 * 
 * IMPORTANTE: Este archivo es SEGURO y NO modifica archivos existentes
 */

// Verificar si los logs de debug están desactivados
const isDebugDisabled = () => {
  if (typeof window === 'undefined') return false;
  
  const debugLogs = process.env.NEXT_PUBLIC_DEBUG_LOGS;
  return debugLogs === 'false';
};

// Guardar las funciones originales de console
const originalConsole = {
  log: console.log,
  warn: console.warn,
  error: console.error,
  info: console.info,
  debug: console.debug
};

// Función para inicializar el override
export const initializeConsoleOverride = () => {
  if (typeof window === 'undefined') return;
  
  if (isDebugDisabled()) {
    // Desactivar logs de debug pero mantener errores
    console.log = () => {};
    console.info = () => {};
    console.debug = () => {};
    console.warn = () => {};
    
    // Mantener console.error para errores críticos
    // console.error se mantiene activo
    
    console.log('🔇 [CONSOLE OVERRIDE] Logs de debug desactivados para VPS');
  } else {
    console.log('🔊 [CONSOLE OVERRIDE] Logs de debug activados para desarrollo');
  }
};

// Función para restaurar console original (útil para debugging)
export const restoreConsole = () => {
  if (typeof window === 'undefined') return;
  
  console.log = originalConsole.log;
  console.warn = originalConsole.warn;
  console.error = originalConsole.error;
  console.info = originalConsole.info;
  console.debug = originalConsole.debug;
  
  console.log('🔄 [CONSOLE OVERRIDE] Console original restaurado');
};

// Función para verificar el estado actual
export const getConsoleStatus = () => {
  return {
    debugDisabled: isDebugDisabled(),
    originalConsole: originalConsole,
    currentConsole: {
      log: console.log,
      warn: console.warn,
      error: console.error,
      info: console.info,
      debug: console.debug
    }
  };
};

